import { Sidebar } from 'semantic-ui-react';
import styled from 'styled-components';

export const Pushable = styled(Sidebar.Pushable)<{ isCollapsed?: boolean }>`
  position: relative;
  .pusher {
    position: relative;
    overflow: initial !important;
  }
  .ui.left.visible.sidebar,
  .ui.right.visible.sidebar {
    box-shadow: none !important;
  }
  .ui.visible.left.sidebar~.fixed, 
  .ui.visible.left.sidebar~.pusher {
    transform: translateX(${props => props.isCollapsed ? sideBarCollapsedWidth : sideBarWidth}) !important;
    transition: transform 0.3s ease !important;
  }
`;

const sideBarWidth = '268px';
const sideBarCollapsedWidth = '70px';

export const NavbarContainer = styled.div`
  width: 100%;
`;

export const ContentContainer = styled.div<{ isCollapsed?: boolean }>`
  height: calc(100vh - 2px);
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: calc(100% - ${props => props.isCollapsed ? sideBarCollapsedWidth : sideBarWidth});
  margin-top: 2px;
`;

export const Content = styled.div`
  padding: 2em 2em 8em 2em;
  @media (max-width: 768px) {
    padding: 14px;
  }
`;

export const SidebarPusher = styled(Sidebar.Pusher)``;

export const SidebarWrapper = styled(Sidebar)<{ isCollapsed?: boolean }>`
  overflow-x: hidden;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 10;
  width: ${props => props.isCollapsed ? sideBarCollapsedWidth : sideBarWidth} !important;
  transition: width 0.3s ease;
`;
